import { moduleTypes, roles } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import React from "react";
import { getOrganizationNames } from "sources/admin";

const config = {
    header: {
        label: "Название",
        inputProps: { name: "header" },
        validators: [requiredField],
        required: true,
    },
    text: {
        label: "Текст уведомления",
        inputProps: { name: "text" },
        validators: [requiredField],
        required: true,
    },
    noWayToClose: {
        label: "Без возможности закрытия",
        inputProps: { name: "noWayToClose" },
        checkbox: true,
    },
    forWhiteListOrganizations: {
        label: "Для белого списка организаций",
        inputProps: { name: "forWhiteListOrganizations" },
        checkbox: true,
    },
    countOfExpiredDays: {
        label: "Кол-во дней просрочки",
        inputProps: {
            name: "countOfExpiredDays",
            type: "number",
            step: 1,
            onKeyDown: (e) => ["e", "E", "+", "-", ".", ","].includes(e.key) && e.preventDefault(),
        },
    },
    daysBeforeSubscriptionExpires: {
        label: "Кол-во дней до конца подписки",
        inputProps: {
            name: "daysBeforeSubscriptionExpires",
            type: "number",
            step: 1,
            onKeyDown: (e) => ["e", "E", "+", "-", ".", ","].includes(e.key) && e.preventDefault(),
        },
    },
    daysUntilBlocking: {
        label: "Кол-во дней после окончания подписки, через которое будет заблокирован кабинет",
        inputProps: {
            name: "daysUntilBlocking",
            type: "number",
            step: 1,
            onKeyDown: (e) => ["e", "E", "+", "-", ".", ","].includes(e.key) && e.preventDefault(),
        },
    },
    moduleType: {
        label: "Модуль",
        inputProps: { name: "moduleType" },
        options: moduleTypes,
    },
    organizationIds: {
        // select
        label: "Организации",
        inputProps: { name: "organizationIds" },
        url: getOrganizationNames,
        propName: "name",
        menuPortalTarget: document.body,
        menuPlacement: "top",
        isMulti: true,
    },
    roles: {
        // select
        label: "Роли",
        inputProps: { name: "roles" },
        options: roles,
        menuPortalTarget: document.body,
        menuPlacement: "top",
        isMulti: true,
        placeholder: <small>Всем ролям</small>,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
